import React, { useState } from "react";
import { Button, Divider, Flex, Group, Stack, Card } from "@mantine/core";
import { IconTarget, IconHomeStar } from "@tabler/icons-react";
import { shallow } from "zustand/shallow";
import { useTranslation } from "react-i18next";

import UserDashboard from "./UserDashboard";
import { MicrositeUserEmailStreams } from "@components/Email";
import PreferredLocation from "./PreferredLocation";
import { LocationInfo } from "@components/RideChallengeApp/RideChallengeDashboard";

import useAppStore from "./microsite-store";

export default function UserView({ fetchUser }) {
  const [preferredLocationVisible, setPreferredLocationVisible] =
    useState(false);
  const {
    emailStreams,
    entityInfo,
    preferredLocation,
    user,
    setEmailStreams,
    location,
  } = useAppStore(
    (state) => ({
      emailStreams: state.emailStreams,
      entityInfo: state.entityInfo,
      preferredLocation: state.preferredLocation,
      user: state.user,
      setEmailStreams: state.setEmailStreams,
      location: state.location,
    }),
    shallow
  );

  const showPreferredLocation = entityInfo.preferred_location;

  const { t } = useTranslation();

  if (preferredLocationVisible) {
    return (
      <div>
        <PreferredLocation
          onSubmit={() => {
            setPreferredLocationVisible(false);
          }}
        >
          <Flex justify="center">
            <Button
              variant="subtle"
              color="gray"
              size="xs"
              onClick={() => setPreferredLocationVisible(false)}
            >
              {t("back_button")}
            </Button>
          </Flex>
        </PreferredLocation>
      </div>
    );
  }

  return (
    <React.Fragment>
      <UserDashboard fetchUser={fetchUser} />
      {true && (
        <React.Fragment>
          <Stack justify="center" mt="lg">
            {/* <Group>
              <Button
                onClick={() => {
                  setShowOtherEfforts(true);
                }}
                radius="xl"
              >
                {t("user_select_different_campaign_button")}
              </Button>
            </Group> */}
            {showPreferredLocation && (
              <>
                {preferredLocation ? (
                  <>
                    <Card>
                      <LocationInfo
                        info={preferredLocation}
                        title={t("preferred_location_title")}
                        onClick={() => setPreferredLocationVisible(true)}
                      />
                    </Card>
                  </>
                ) : (
                  <>
                    <Button
                      onClick={() => setPreferredLocationVisible(true)}
                      variant="subtle"
                      color="gray"
                      leftSection={<IconHomeStar />}
                    >
                      {t("add_preferred_location_button")}
                    </Button>
                  </>
                )}
              </>
            )}
          </Stack>
          {user && (
            <>
              <Divider mt="lg" mb="lg" opacity={0.15} />
              <MicrositeUserEmailStreams
                user={user}
                streams={emailStreams}
                onChange={(e) => {
                  setEmailStreams(e);
                }}
              />
            </>
          )} */}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
